
import ProvidersPage from "./ProvidersPage";
import CompanyDetailPage from "./CompanyDetailPage";

export default class ProviderDetailPage extends CompanyDetailPage {
  static PageInfo = {
    
    parent: ProvidersPage,
    hidden:true,
    path: "/Admin/Providers/Detail/:id",
    name: "menu.provider",
    access: { 1: true },
    permission: { "CONFIGURATION_USERS_ACCESSING": true },
    icon: "store"
  }
}  